import realpressContactForm from './shortcode/contact-form/contact-form';

document.addEventListener( 'DOMContentLoaded', ( event ) => {
	realpressContactForm();
} );
